import React, { useRef } from "react";
import {
  ShiftAdjustMealBreakContainer,
  ShiftAdjustMealBreakTitle,
  ShiftAdjustMealBreakContent,
  ShiftAdjustMealBreakActions,
  ShiftAdjustDeleteButton,
} from "./styledComponents";
import { ShiftAdjustTimePicker } from "./ShiftAdjustTimePicker";
import { TimeArrow } from "../arrow";
import { useFocusGroup } from "../../../../../../shared/hooks/useFocusGroup";
import { getDisplayDurationInMinutes } from "../../breakUtils";

export type MealBreak = {
  id: string;
  start?: Date;
  end?: Date;
};

export type ShiftAdjustMealBreakProps = {
  mealBreak: MealBreak;
  breakNumber: number;
  onUpdate: (mealBreak: MealBreak) => void;
  onDelete: (id: string) => void;
  formattedTimezone?: string;
};

export const ShiftAdjustMealBreak = ({
  mealBreak,
  breakNumber,
  onUpdate,
  onDelete,
  formattedTimezone,
}: ShiftAdjustMealBreakProps) => {
  const breakStartOverlayRef = useRef<HTMLElement|null>(null);
  const breakEndOverlayRef = useRef<HTMLElement|null>(null);

  const {
    hasFocus: showKeyboardInputs,
    containerRef,
    focusProps,
  } = useFocusGroup({
    extraRefs: [breakStartOverlayRef, breakEndOverlayRef],
  });

  const handleMealStartChange = (value: Date)=> {
    onUpdate({
      ...mealBreak,
      start: value,
    });
  }
  const handleMealEndChange = (value: Date)=> {
    onUpdate({
      ...mealBreak,
      end: value,
    });
  }

  return (
    <ShiftAdjustMealBreakContainer
      tabIndex={breakNumber}
      ref={containerRef as React.RefObject<HTMLDivElement>}
      {...focusProps}
    >
      <ShiftAdjustMealBreakTitle>Meal break {breakNumber} ({getDisplayDurationInMinutes(mealBreak)})</ShiftAdjustMealBreakTitle>
      <ShiftAdjustMealBreakContent>
        <ShiftAdjustTimePicker
          label={`Break start ${breakNumber}`}
          setDate={handleMealStartChange}
          date={mealBreak.start}
          showKeyboardInput={showKeyboardInputs}
          onOverlayShow={(overlay) => {breakStartOverlayRef.current = overlay;}}
          onOverlayHide={() => {breakStartOverlayRef.current = null;}}
          formattedTimezone={formattedTimezone}
        />
        <TimeArrow />
        <ShiftAdjustTimePicker
          label={`Break end ${breakNumber}`}
          setDate={handleMealEndChange}
          date={mealBreak.end}
          showKeyboardInput={showKeyboardInputs}
          onOverlayShow={(overlay) => {breakEndOverlayRef.current = overlay;}}
          onOverlayHide={() => {breakEndOverlayRef.current = null;}}
          formattedTimezone={formattedTimezone}
        />
        <ShiftAdjustMealBreakActions>
          <ShiftAdjustDeleteButton
            icon="pi pi-trash"
            onClick={() => onDelete(mealBreak.id)}
            className="p-button-text"
          />
        </ShiftAdjustMealBreakActions>
      </ShiftAdjustMealBreakContent>
    </ShiftAdjustMealBreakContainer>
  );
};
